import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import apiUrl from "../libs/baseUrl";
import { errorHandeling } from "../errorHandeling";

export default function useDisciplinaryCases({ page = 1, filters = {} }) {
  const token = useSelector((state) => state.user.token);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(page);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // 🧩 تنظيف وتجهيز params
  const buildParams = (pageNumber, filters) => {
    const params = { page: pageNumber };

    if (filters.search?.trim()) {
      params.search = filters.search.trim();
    }

    if (filters.employee_job_id) {
      params.employee_job_id = filters.employee_job_id;
    }

    if (filters.from_date) {
      params.from_date = filters.from_date;
    }

    if (filters.to_date) {
      params.to_date = filters.to_date;
    }

    if (filters.status) {
      params.status = filters.status;
    }

    return params;
  };

  // 🚀 جلب البيانات
  const fetchCases = useCallback(
    async (pageNumber = 1, activeFilters = {}) => {
      if (!token) return;

      console.log("📡 API REQUEST PARAMS:", buildParams(pageNumber, activeFilters));

      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${apiUrl}/disciplinary-cases`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
            params: buildParams(pageNumber, activeFilters),
          }
        );

        if (response.data?.status === "success") {
          const result = response.data.data;

          setData(result.data ?? []);
          setCurrentPage(result.current_page ?? 1);
          setTotalPages(result.last_page ?? 1);
        } else {
          setData([]);
          setError("فشل في جلب البيانات");
        }
      } catch (err) {
        setData([]);
        setError(errorHandeling(err));
      } finally {
        setLoading(false);
      }
    },
    [token]
  );

  // 🔁 إعادة الجلب عند تغيير الصفحة أو الفلاتر
  useEffect(() => {
    fetchCases(page, filters);
  }, [page, filters, fetchCases]);

  return {
    data,
    currentPage,
    totalPages,
    isLoading: loading,
    isFetching: loading,
    error,
    refetch: fetchCases,
  };
}